import CustomerIndex from "~/pages/email/customer/Index.vue";
import ViewScreen from "~/pages/email/customer/screens/View.vue";
import CreateScreen from "~/pages/email/customer/screens/Create.vue";
import ReplyOrForwardScreen from "~/pages/email/customer/screens/ReplyOrForward.vue";

export default [
  {
    path: "/",
    component: CustomerIndex,
    name: "customerEmail",
    children: [
      {
        path: "show/:emailId",
        component: ViewScreen,
      },
      {
        path: "create",
        component: CreateScreen,
      },
      {
        path: "create/for/:instanceClass/id/:instanceId",
        component: CreateScreen,
      },
      {
        path: "create/for/category/:category",
        component: CreateScreen,
      },
      {
        path: "reply/:emailId",
        component: ReplyOrForwardScreen,
        props: () => ({
          initialSendState: "reply",
        }),
      },
      {
        path: "forward/:emailId",
        component: ReplyOrForwardScreen,
        props: () => ({
          initialSendState: "forward",
        }),
      },
    ],
  },
];
